import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';
import './home.scss';
import DisplayList from '../app/components/DisplayList';
import Sounds from '../app/Sounds';

class Home {
  constructor() {
    this.layout();
    this.initButtons();
    this.initPopup();
  }

  layout() {
    const ticketBtn = settings.sections.home.items.find((o) => o.id === 'ticketsBtn');
    ticketBtn.label = settings.releaseDate.ticketButtonLabel;
    ticketBtn.properties.href = settings.releaseDate.orderLink;

    document.querySelector('#shell').appendChild(
        Localizr.template(Preloader.getFile('home-template'), {
          date: settings.releaseDate,
          title: settings.simpleTitle,
          ticketArt: settings.releaseDate.ticketArt,
        })
    );
    if (settings.releaseDate.ticketArt) {
      document.querySelector('#ticketsBtn').classList.add('tickets');
    }
    Localizr.parseObjectList(settings.sections.home.items);
    DisplayList.create(
        {
          section: '<a class="section-nav-btn" href="{{href}}"><div class="label">{{label}}</div class="label"></a>',
          link:
          '<a class="section-nav-btn" href="{{href}}" target="_blank"><div class="label">{{label}}</div class="label"></a>',
        },
        settings.sections.home.nav,
        document.querySelector('.section-nav')
    );
  }

  initButtons() {
    document.querySelector('.soundIcon').addEventListener('click', () => {
      Sounds.toggleMute();
    });
  }

  preenter() {}

  enter() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}

  initPopup() {
    this.canPunch = true;
    this.punch = document.querySelector('.punch');
    this.punch.addEventListener('click', this.onPunch.bind(this));
    setTimeout(this.showBag.bind(this), 2000);
    this.bagPositions = ['pos1', 'pos2', 'pos3', 'pos4', 'pos5', 'pos6'];
    this.bagPosition = 0;
  }

  showBag() {
    this.canPunch = true;
    this.punch.classList.remove(this.bagPositions[this.bagPosition]);
    this.bagPosition = (this.bagPositions.length * Math.random()) | 0;
    this.punch.classList.add(this.bagPositions[this.bagPosition]);
    this.punch.classList.remove('punched');
    this.closeTO = setTimeout(this.hideBag.bind(this), 2000);
    this.punch.classList.add('show');
  }

  hideBag() {
    this.canPunch = false;
    clearTimeout(this.closeTO);
    this.punch.classList.remove('show');
    setTimeout(this.showBag.bind(this), 12000);
  }

  onPunch() {
    if (!this.canPunch) {
      return;
    }
    this.canPunch = false;
    Sounds.playSound('punch');
    this.punch.classList.add('punched');
    clearTimeout(this.closeTO);
    this.closeTO = setTimeout(this.hideBag.bind(this), 300);
    setTimeout(this.showBag.bind(this), 12300);
  }
}

export default Home;
